import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/page/index'),
      meta: {
        title: false
      }
    },
    {
      path: '/index',
      component: () => import('@/page/index'),
      meta: {
        title: 'Thermage Beauty'
      }
    },
    {
      path: '/index2',
      component: () => import('@/page/index2'),
      meta: {
        title: 'Thermage Beauty'
      }
    },
    {
      path: '/product',
      component: () => import('@/page/product'),
      meta: {
        title: '正品设备验真'
      }
    },
    {
      path: '/product2',
      component: () => import('@/page/product2'),
      meta: {
        title: '正品探头验真'
      }
    },
    {
      path: '/product3/:id',
      component: () => import('@/page/product3'),
      meta: {
        title: '正品产品验真'
      }
    },
    {
      path: '/productPda',
      component: () => import('@/page/productPda'),
      meta: {
        title: 'Merzcheck'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js